/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface EncoderMode {
}

export enum EncoderMode_Enum {
  FORMAT_DEFAULT = 0,
  FORMAT_AVC = 1,
  FORMAT_HEVC = 2,
  FORMAT_HEVC_10BIT = 3,
  UNRECOGNIZED = -1,
}

export function encoderMode_EnumFromJSON(object: any): EncoderMode_Enum {
  switch (object) {
    case 0:
    case "FORMAT_DEFAULT":
      return EncoderMode_Enum.FORMAT_DEFAULT;
    case 1:
    case "FORMAT_AVC":
      return EncoderMode_Enum.FORMAT_AVC;
    case 2:
    case "FORMAT_HEVC":
      return EncoderMode_Enum.FORMAT_HEVC;
    case 3:
    case "FORMAT_HEVC_10BIT":
      return EncoderMode_Enum.FORMAT_HEVC_10BIT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EncoderMode_Enum.UNRECOGNIZED;
  }
}

export function encoderMode_EnumToJSON(object: EncoderMode_Enum): string {
  switch (object) {
    case EncoderMode_Enum.FORMAT_DEFAULT:
      return "FORMAT_DEFAULT";
    case EncoderMode_Enum.FORMAT_AVC:
      return "FORMAT_AVC";
    case EncoderMode_Enum.FORMAT_HEVC:
      return "FORMAT_HEVC";
    case EncoderMode_Enum.FORMAT_HEVC_10BIT:
      return "FORMAT_HEVC_10BIT";
    case EncoderMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseEncoderMode(): EncoderMode {
  return {};
}

export const EncoderMode = {
  encode(_: EncoderMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EncoderMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEncoderMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): EncoderMode {
    return {};
  },

  toJSON(_: EncoderMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<EncoderMode>, I>>(base?: I): EncoderMode {
    return EncoderMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EncoderMode>, I>>(_: I): EncoderMode {
    const message = createBaseEncoderMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
